module.exports = __webpack_public_path__ + "static/media/corezoneblack.7d805e79.png";